import useAuthSubscriptionIsExpired from '@apps/www/src/www/hooks/useAuthSubscriptionIsExpired';
import { useRouter } from 'next/router';

const OPT_OUT_PATH_PREFIXES = [
	'/billing/',
	'/california-privacy-statement/',
	'/community-guidelines/',
	'/companies/',
	'/contact-sales/',
	'/contact/',
	'/copyright-policy/',
	'/course/',
	'/extension/',
	'/figma/',
	'/i/', // detail page
	'/import/',
	'/lists/',
	'/logout/',
	'/marketplace/',
	'/notice-for-non-users/',
	'/platform-enforcement-policy/',
	'/pricing/',
	'/privacy/',
	'/profile/',
	'/settings/',
	'/site-maker/',
	'/team/create/',
	'/team/settings/',
	'/team/users/',
	'/terms/',
	'/trademark-policy/',
	'/upgrade/',
	'/users/',
];

const useCanSeeUpgradeWarning = () => {
	const router = useRouter();

	const routerPath = router.asPath;

	const hasExpiredSubscription = Boolean(useAuthSubscriptionIsExpired());

	// Don't show upgrade warning on home page or search page if user has
	// expired subscription because we're already blocking the feed and
	// displaying a notice in the middle of the page
	if (
		(routerPath === '/' ||
			routerPath.startsWith('/search/') ||
			routerPath.startsWith('/pop/')) &&
		hasExpiredSubscription
	) {
		return false;
	}

	// TODO: In the future, when we have a hook to identify what kind of page we're on. Make this opt-in instead of opt-out.
	// Then we can easily add the relevant pages to show the upgrade warning (feed, search, profile, board, other users profiles...)
	// Then this list doesn't have to be maintained anymore.
	if (OPT_OUT_PATH_PREFIXES.some((prefix) => routerPath.startsWith(prefix))) {
		return false;
	}

	return true;
};

export default useCanSeeUpgradeWarning;
